define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.concat;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/concat.js
// module id = 432
// module chunks = 17 22 23